import { Component, Inject, OnInit,ChangeDetectorRef  } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ProjectsapiService } from 'src/app/services/projectsapi.service';
import { SecurityLevelsApiService } from 'src/app/services/security-levels-api.service';
import { Project } from 'src/app/interfaces/project';
import { SecurityLevel } from 'src/app/interfaces/security-level';
import { Users } from '../../../model/structures';
import { AuthenticationService } from '../../../services/authentication.service';
@Component({
  selector: 'app-project-dialog',
  templateUrl: './project-dialog.component.html',
  styleUrls: ['./project-dialog.component.css'],
})
export class ProjectDialogComponent implements OnInit {
   form: any;
    project: Project;
    security_levels: SecurityLevel[] = [];
    description: string;
    start: Date = new Date();
    end: Date = new Date();
    executor: string = '';
    customer: string = '';
    short_title: string = '';
    selected_security_level_title: string;
    security_level: SecurityLevel = { ID: -1, ShortTitle: '' };
    appearance: 'fill' | 'outline' | 'legacy' = 'legacy';
  id: number = -1;
  saved: boolean = false;
  selectedTabIndex: number = 0;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ProjectDialogComponent>,
    private security_levels_api: SecurityLevelsApiService,
    private projects_api: ProjectsapiService,
    private authServ: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) data: any,
    private cdr: ChangeDetectorRef
  ) {
    this.description = data.description;
    this.project = data.project;
    if(!data.project){    

      this.description = '';
      this.start = new Date();
      this.end = new Date();
      this.short_title = '';
      this.executor ='';
      this.customer = '';
      this.selected_security_level_title = '';
    }
    else{
      this.id=this.project.ID;
      this.description = this.project.Description;
      this.start = new Date(this.project.StartDate);
      this.end = new Date(this.project.EndDate);
      this.short_title = this.project.ShortTitle;
      this.executor = this.project.Executor;
      this.customer = this.project.Customer;
      this.selected_security_level_title = this.project.SecurityLevel;
      this.saved=true;
      
    }
    
  }
  

  ngOnInit() {
    this.form = this.fb.group({
      short_title: [this.short_title, []],
      description: [this.description, []],
      start: [this.start, []],
      end: [this.end, []],
      security_level: [this.security_level, []],
      customer: [this.customer, []],
      executor: [this.executor, []],
    });
    
    this.security_levels_api.getSecurityLevels().subscribe((res) => {
      this.security_levels = res;
      let tmp = this.security_levels.find(
        (x) => x.ShortTitle === this.selected_security_level_title
      );

      if (tmp !== undefined) {
        this.form.get('security_level').setValue(tmp);
      }
    });
    this.dialogRef.updateSize('80%', '100%');
    

  }

  save() {
    
    if(this.id===-1){
      this.projects_api.save(this.form?.value,  this.authServ.getUser())?.subscribe((res:any) => {
      this.id = res.id
      });
      //this.form.disable();
      //this.openNextTab(); 
    }else{
      this.projects_api.update(this.id, this.form?.value,  this.authServ.getUser())?.subscribe((res:any) => {
      });
    }
  
    
    //this.dialogRef.close(this.form?.value);
  }

  openNextTab(){
    this.selectedTabIndex=1;
  }

  close() {
    this.dialogRef.close();
  }
}
